/**
 * Created by chachora on 11/28/18.
 */
import { EVENTS_GET, EVENT_DELETE, EVENT_UPDATE } from './events.actions';
import { SlotEvent } from '../model/types';

type EventsState = {
  range: { start: Date; end: Date } | null;
  list: SlotEvent[];
  byId: Map<string, SlotEvent>;
};

const initialState: EventsState = {
  range: null,
  list: [],
  byId: new Map(),
};

export type EventsAction =
  | {
      type: typeof EVENTS_GET;
      payload: {
        events: SlotEvent[];
        range: { start: Date; end: Date };
      };
    }
  | {
      type: typeof EVENT_UPDATE;
      payload: {
        event: SlotEvent;
      };
    }
  | {
      type: typeof EVENT_DELETE;
      payload: {
        eventId: string;
      };
    };

const getEventIndex = (list: SlotEvent[], id: string): number =>
  list.findIndex(item => item._id === id);

export const eventsReducer = (
  state: EventsState = initialState,
  action: EventsAction
): EventsState => {
  switch (action.type) {
    case EVENTS_GET: {
      const { events, range } = action.payload;
      const isEqual =
        range.start.getTime() === state.range?.start.getTime() &&
        range.end.getTime() === state.range?.end.getTime() &&
        events.length === state.list.length &&
        events.every(
          (event, i) =>
            event._id === state.list[i]._id &&
            event.updatedAt === state.list[i].updatedAt
        );
      if (isEqual) {
        return state;
      }

      const list = [...events];
      const byId = new Map(list.map(event => [event._id, event]));

      return {
        ...state,
        range,
        list,
        byId,
      };
    }
    case EVENT_UPDATE: {
      const { list } = state;
      const { event } = action.payload;
      const index = getEventIndex(list, event._id);
      if (index < 0) return state;
      const newList = [
        ...list.slice(0, index),
        event,
        ...list.slice(index + 1),
      ];
      const byId = new Map(newList.map(event => [event._id, event]));
      return {
        ...state,
        list: newList,
        byId,
      };
    }
    case EVENT_DELETE: {
      const { list } = state;
      const index = getEventIndex(list, action.payload.eventId);
      if (index < 0) return state;
      return {
        ...state,
        list: [...list.slice(0, index), ...list.slice(index + 1)],
      };
    }
    default:
      return state;
  }
};
